module.exports = __webpack_public_path__ + "img/diente.1500c766.png";